

<template>
        <div class="sekcija" v-if="podatki">
    	      <!--<div class="sekcija" v-if="podatki.find(i=>i.statuspridelkanaziv=='Ekološki')||podatki.find(i=>(i.statuspridelkanaziv=='Iz preusmeritve'||i.statuspridelkanaziv=='1. leto preusmeritve'))"> -->
  
        <div class="kategorije">
        <!--<div class="naslov">Proizvodi in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 (2) za proizvode s področja uporabe Uredbe (EU) 2018/848</div>-->
        <div class="naslov-kategorije">
            {{naslov}}
        </div>
        <div class="naslov">
        {{__("Metoda pridelave:")}}
        </div>
        <div v-for="status of podatki.status">
            <div>
                 {{status}}
            </div>
          <!--  <div class="proizvodi">
                <div class="proizvodi-row" v-for="proizvod in podatki.konvencionalno.map(i=>i.naziv)">
                    <div class="proizvodi-ime">{{proizvod}}</div>  
                    <div class="proizvodi-status">Konvencionalno</div>  
                </div>  
            </div>  
        -->
        </div>
       

        
        
</div> 

</div>
</template>
<script>
export default {
    props: ["naslov","proizvod","podatki"],
   
    created(){
        console.log(this.podatki)
    },
    methods:{
        __: function(value){

        if(!this.$route.query.lang)
            return value


        let lang=this.$route.query.lang
        var translation={};

        translation["de"]={
                 "Metoda pridelave:":"Produktionsverfahren:",
                 "ekološka pridelava z neekološko pridelavo":"ökologische/biologische Produktion mit nichtökologischer/nichtbiologischer Produktion",
                 "ekološka pridelava, razen v obdobju preusmeritve":"ökologische/biologische Produktion außer während des Umstellungszeitraums",
                 "pridelava ekoloških proizvodov":"Produktion ökologischer/biologischer Erzeugnisse",
                 "pridelava v obdobju preusmeritve":"Produktion während des Umstellungszeitraums",
                 "pridelava proizvodov iz preusmeritve":"Produktion von Umstellungserzeugnissen",
            };
              translation["en"]={
                 "Metoda pridelave:":"Production method:",
                 "ekološka pridelava z neekološko pridelavo":"organic production with non-organic production",
                 "ekološka pridelava, razen v obdobju preusmeritve":"organic production excluding during the conversion period",
                 "pridelava ekoloških proizvodov":"production of organic products",
                 "pridelava v obdobju preusmeritve":"production during the conversion period",
                 "pridelava proizvodov iz preusmeritve":"production of in-conversion products",
            };

        if(!translation[lang])
              return value;

        return translation[lang][value]?translation[lang][value]:value;


        }   
    }

 }
</script>
<style scoped>
.proizvodi-row{
    display:flex;
    flex-direction:row;
    justify-content:space-between;
}
.kategorije{
    margin-top:1em;
    margin-bottom:1em;
    border: 1px solid var(--accent);
    padding: 0.5em;
}
.naslov-kategorije {
   
    margin-bottom:0.5em;
    font-weight:bold;
  
     color:var(--accent);
}
.proizvodi {
    margin-top:0.5em;
    margin-bottom:0.5em;
}

.proizvodi-ime,.proizvodi-status{
    font-weight:bold;
}
</style>
